import { render } from "./Athlete.vue?vue&type=template&id=72270ac0&scoped=true&ts=true"
import script from "./Athlete.vue?vue&type=script&lang=ts"
export * from "./Athlete.vue?vue&type=script&lang=ts"

import "./Athlete.vue?vue&type=style&index=0&id=72270ac0&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72270ac0"]])

export default __exports__